import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class ButtonClickApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.ButtonClick;

  constructor(
    private event: string,
    private category: string,
    private action?: string,
    private label?: string
  ) {}

  getPayload(): any {
    return {
      event: this.event,
      category: this.category,
      action: this.action,
      label: this.label
    };
  }
}
